import { render, staticRenderFns } from "./FilterProvider.vue?vue&type=template&id=12bccae4&scoped=true&lang=pug&"
import script from "./FilterProvider.vue?vue&type=script&lang=js&"
export * from "./FilterProvider.vue?vue&type=script&lang=js&"
import style0 from "./FilterProvider.vue?vue&type=style&index=0&id=12bccae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bccae4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDivider,VIcon,VMenu,VProgressCircular,VSkeletonLoader,VSpacer,VTextField})
